import Vue from 'vue'
import Vuex from 'vuex'
import Persisted from 'vuex-persistedstate'

import users from './modules/Users'
import loader from './modules/Loader'
import Investment from '@/common/store/Investment'
import notifications from '@/common/store/Notifications'
import estate from '@/common/store/PatrimonialEstate'
import chat from '@/common/store/Chat'
import documents from '@/common/store/Documents'
import news from '@/common/store/News'
import transactions from '@/common/store/Transactions'
import subscriptions from '@/common/store/Subscriptions'
import plans from '@/common/store/Plans'
import Site from '@/common/store/Site'
import { STORAGE_KEY } from './state'

Vue.use(Vuex)

const store = new Vuex.Store({
	strict: true,
	plugins: [Persisted({
		key: STORAGE_KEY
	})],
	modules: {
		loader,
		users,
		notifications,
		estate,
		chat,
		documents,
		news,
		transactions,
		subscriptions,
		plans,
		Investment,
		Site
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js